import { uniqBy } from 'lodash';
import { useState } from 'react';
import type { FieldValues } from 'react-hook-form';
import type { FormErrorNotificationContextProps } from '../../../form-error-notification-context/form-error-notification-context';
import type { FormErrorField } from '../../../form-error-notification-context/form-error-notification-context-types/form-error-field';

export function useErrorNotification<
  InputForm extends FieldValues,
  Tab extends string | undefined = undefined,
>(): FormErrorNotificationContextProps<InputForm, Tab> {
  const [errorsFields, setErrorsFields] = useState<FormErrorField<InputForm, Tab>[]>([]);
  const [showErrorNotification, setShowErrorNotification] = useState(false);

  const registerErrorField = (field: string, tab?: Tab) => {
    if (errorsFields.findIndex((errorField) => errorField.fieldPath === field) !== -1) {
      return;
    }

    setErrorsFields((currentErrorsFields) =>
      uniqBy(
        [
          ...currentErrorsFields,
          {
            fieldPath: field,
            tab,
          } as FormErrorField<InputForm, Tab>,
        ],
        'fieldPath',
      ),
    );
  };

  const registerErrorCustomField = (field: string, tab?: Tab) => {
    registerErrorField(field, tab);
  };

  return {
    errorsFields,
    registerErrorField,
    registerErrorCustomField,
    showErrorNotification,
    setShowErrorNotification,
  };
}
